import styled from 'styled-components';

export const ButtonContainer = styled.button<{ $active: boolean }>`
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: ${({ $active }) => ($active ? 'white' : 'transparent')};
  color: ${({ $active }) => ($active ? 'black' : 'white')};
  border: 2px solid white;
  border-radius: 8px;
  padding: 4px 8px;
  font-weight: bold;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 10;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;
